<div class="app-container">
  <aside class="order-sidebar">
    <bst-frontend-left-panel
      *ngIf="orderData"
      [orderData]="orderData"
      [isPickupLocation]="isPickupLocation"
      (openPickup)="onOpenPickupFromLeft()"
    ></bst-frontend-left-panel>
  </aside>
  <main class="main-content">
    <bst-frontend-right-panel
      #rightPanel
      *ngIf="orderData"
      [orderData]="orderData"
      [isPickupLocation]="isPickupLocation"
    ></bst-frontend-right-panel>
  </main>
</div>
